import {
  useLayoutEffect,
  useState,
} from 'react';

import { coachingAPI } from 'api/coachingAPI';
import { cloneDeep } from 'lodash';
import { isEmpty } from 'util/isEmpty';
import {useRecoilValue} from "recoil";
import {isAdmin} from "../state";

const useGetCoachingData = (classId = "", path = "", def?: any) => {
    const [data, setData] = useState(null);
    const [list, setList] = useState([]);
    const [stepData, setStepData] = useState(null);
    const admin = useRecoilValue(isAdmin);
    const getCoachingData = async () => {
        if (isEmpty(classId)) return;
        await coachingAPI.getProductById(classId, null).then((res) => {
            console.log("st", res);
            setData(cloneDeep(res?.data));
        });
    };

    const getCoachingList = async () => {
       await coachingAPI
            .getCoachingList({
                params: {
                    progress:"IN_PROGRESS",

                },
            })
            .then((res) => {
                console.log("coa data", res);
                setList(cloneDeep(res?.content));
                const c = cloneDeep(res?.content);
                const find = c.find(item => {
                   return item.id === classId
                })
                setData(cloneDeep(find))
            });
    };

    //   const getClassStepData = async () => {
    //       if(isEmpty(classId)) return;
    //       const result = await classesAPI[path](classId, null)
    //       .then((res:any) => {
    //           return res?.data
    //       });

    //       setStepData(cloneDeep(result))
    //   }

    useLayoutEffect(() => {
        getCoachingData();
        //   getClassStepData()
    }, [classId, def]);

    return { data, stepData };
};
export default useGetCoachingData;
